import React from "react";
import "./App.css";
import Array from "./components/Array";
import Header from "./components/Header";

function App() {
  return (
    <div className="bg">
      <div className="App">
        <Header />
        <Array />
      </div>
    </div>
  );
}

export default App;
